module.exports = __webpack_public_path__ + "img/prestashop.9a13164d.png";